import { ResponseDto } from './../../../../models/exceptions/response-dto';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import { SportTournamentTemplateDto } from '@models/clash/SportTorneioTemplate/sport-tournament-template-dto';
import { BaseService } from '@shared/services/base-service';
import { Observable } from 'rxjs';
import { url } from 'src/app/core/utilities/utility-functions';

@Injectable({
  providedIn: 'root'
})
export class SportTorneioTemplateService extends BaseService {

  urlApi = environment.apiUrl + '/v1/esportes-torneios-templates';

  searchSportsTournamentsTemplatesById(ettNrId: number): Observable<ResponseDto<SportTournamentTemplateDto>> {
    return this.http.get<ResponseDto<SportTournamentTemplateDto>>(url(this.urlApi, ettNrId))
  }
}
